<section class="toggle-form" [ngClass]="{ active: isCourseSliderOpen }">
  <div class="formwrap">
    <div>
      <p-button
        appPreventDoubleClick
        styleClass="p-button-text"
        id="documentSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>

    <div class="general-container content">
      <p-tabView [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">

        <!-- GENERAL -->
        <p-tabPanel
          header="General"
          [rightIcon]="errorIconForGeneralTab"
        >
          <ng-template pTemplate="content">
            <app-course-general-details
              (activateTabIndex)="openCurrentTab($event)"
            ></app-course-general-details>
          </ng-template>
        </p-tabPanel>

        <!-- PREREQUISITES -->
        <p-tabPanel
          header="Prerequisites"
          [disabled]="!isEditSlider"
          [rightIcon]="errorIconForPrereqTab"
        >
          <ng-template pTemplate="content">
            <ng-container *ngIf="isPrerequisitesTabActive">
              <app-course-prerequisites
                (activateTabIndex)="openCurrentTab($event)"
                [sliderClosed]="isCourseSliderOpen === false"
                [coursePrerequisites]="courseDetails?.prerequisites"
              ></app-course-prerequisites>
            </ng-container>
          </ng-template>
        </p-tabPanel>

        <!-- TRAINING MATERIAL -->
        <p-tabPanel
          header="Training Material"
          [disabled]="!isEditSlider"
          [rightIcon]="errorIconForTrainingTab"
        >
          <ng-template pTemplate="content">
            <ng-container *ngIf="isTrainingMaterialTabActive">
              <app-course-training-material
                (activateTabIndex)="openCurrentTab($event)"
                [trainingMaterial]="courseDetails?.trainingMaterial"
              ></app-course-training-material>
            </ng-container>
          </ng-template>
        </p-tabPanel>

      </p-tabView>
    </div>
  </div>
</section>
